import { useQuery } from '@tanstack/react-query';

import { SEARCH_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { SearchUsersResponsePagedList } from 'src/types/rest/managementPortalApi';

interface UseSearchUsersProps {
  restrictToZeissEmailDomain: boolean;
  searchQuery?: string;
}

export const useSearchUsers = ({
  restrictToZeissEmailDomain,
  searchQuery,
}: UseSearchUsersProps) => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  const base = new URL(apiHost).origin;

  return useQuery({
    enabled: !!searchQuery,
    queryFn: () =>
      apiRequest<SearchUsersResponsePagedList>({
        data: searchQuery,
        method: 'POST',
        url: `${base}/internal/api/v1/users/search?pageIndex=1&itemsPerPage=${SEARCH_ITEMS_PER_PAGE}${restrictToZeissEmailDomain ? '&emailDomain=zeiss.com' : ''}`,
      }),
    queryKey: ['searchUsers', restrictToZeissEmailDomain, searchQuery],
  });
};
